//---- popup width computation ------------------------------------------------------------
//Shared by the file viewer and yaml editor popups: the popup grows to fit the widest line
//of the loaded text so no horizontal scrollbar is needed; the css caps it at the screen
//width, beyond which the textarea scrolls again. Both textareas are monospace (14px Courier
//New, see the component css), so the widest line in pixels is just the longest tab-expanded
//line times one character's width.

const POPUP_FONT = "14px 'Courier New', Courier, monospace"; //must match the textarea css
export const FALLBACK_CHAR_WIDTH = 8.4; //Courier is ~0.6em wide: 14px * 0.6
export const MIN_POPUP_WIDTH = 480; //title bar + a sensible floor for near-empty files
export const WIDTH_ALLOWANCE = 56; //textarea padding (32) + vertical scrollbar + border slack

const TAB_STOP = 8;

let cachedCharWidth = null;

const charWidth = () => {

    if (null === cachedCharWidth)
    {
        cachedCharWidth = FALLBACK_CHAR_WIDTH;

        //measure the real glyph width where canvas is available (jsdom has none)
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext && canvas.getContext('2d');

        if (ctx)
        {
            ctx.font = POPUP_FONT;
            const measured = ctx.measureText('M').width;

            if (measured > 0)
            {
                cachedCharWidth = measured;
            }
        }
    }

    return cachedCharWidth;
};

//Length in character columns of the widest line, expanding tabs to 8-column stops the same
//way the textarea renders them.
export const widestLineChars = (text) => {

    let widest = 0;
    let column = 0;

    for (let i = 0; i < text.length; i++)
    {
        const ch = text[i];

        if ('\n' === ch)
        {
            column = 0;
        }
        else if ('\t' === ch)
        {
            column = (Math.floor(column / TAB_STOP) + 1) * TAB_STOP;
        }
        else
        {
            column++;
        }

        if (column > widest)
        {
            widest = column;
        }
    }

    return widest;
};

//Popup width in pixels for the given text: widest line plus chrome, never below the floor.
export const computePopupWidth = (text) => {
    return Math.max(MIN_POPUP_WIDTH, Math.ceil(widestLineChars(text) * charWidth()) + WIDTH_ALLOWANCE);
};
